import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby'
import { PrismicRichText } from '@prismicio/react'

export const BlogText = ({ slice }) => {
  const [piwikVisitorId, setPiwikVisitorId] = useState('unknown')
  const {text} = slice.primary

  useEffect(() => {
    if (typeof window !== 'undefined' && window._paq) {
      var _paq = window._paq || []
      _paq.push([
        function () {
          setPiwikVisitorId(this.getVisitorId())
        },
      ])
    }
  }, [])



  return (
      <div className="container px-0 py-4">
        <style>
          {`div[data-oembed-type="video"][data-oembed-provider="YouTube"] {
            text-align: center;
          }
          
          div[data-oembed-type="video"][data-oembed-provider="YouTube"] iframe {
            width: 100%;
            max-width: 100%;
            height: auto;
            aspect-ratio: 16 / 9;
            margin-top: 24px;
            margin-bottom: 24px;
          }

          @media (min-width: 992px) {
            div[data-oembed-type="video"][data-oembed-provider="YouTube"] iframe {
              max-width: 720px;
            }
          }`}
        </style>
        <PrismicRichText
          field={text.richText}
          components={{
            hyperlink: ({ node, children }) => {
              let href = node.data.url;
              const visitorIdPattern = /(\[visitor_id\]=)([^&]*)/;
              
              if (href && visitorIdPattern.test(href)) {
                const target = node.data.target || undefined;
                const rel = target === '_blank' ? 'noopener noreferrer' : undefined;

                console.log(target,rel)
                href = href.replace(visitorIdPattern, `$1${encodeURIComponent(piwikVisitorId)}`);
                return (
                  <a href={href} target={target} rel={rel}>
                    {children}
                  </a>
                );
              }

              return undefined;
            },
          }}
        />
      </div>
  )
}

export const query = graphql`
  fragment BlogItemDataBodyBlogText on PrismicBlogItemDataBodyBlogText {
    slice_type
    primary {
      text {
        richText
      }
    }
  }
  fragment KnowledgeBaseItemDataBodyBlogText on PrismicKnowledgeBaseItemDataBodyBlogText {
    slice_type
    primary {
      text {
        richText
      }
    }
  }
`
